export { ScoreFolio } from './component'
